<!--
 * @Author: your name
 * @Date: 2021-04-27 14:23:35
 * @LastEditTime: 2021-05-26 11:38:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/components/common/platformOrderBatch.vue
-->
<template>
  <div>
    <el-dialog
      title="批量开票提交"
      :visible.sync="batchListModal"
      width="1000px"
      class="yhg-dialog"
      @open="openBatchSelectModal"
      @close="batchClose"
    >
      <div class="filter-con">
        <el-input clearable size="small" v-model="batchForm.batchName" placeholder="批次名称" @keyup.enter.native="onBatchSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onBatchSearch">查 询</el-button>
      </div>
      <div class="table-con">
        <el-table
          :data="batchTable"
          v-loading="batchTableLoading"
          size="mini"
          ref="batchSelectTable"
        >
          <el-table-column label="批次名称" min-width="120" prop="batchName" align="center"></el-table-column>
          <el-table-column label="批次条数" min-width="120" prop="batchNum" align="center"></el-table-column>
          <el-table-column label="批次总金额" min-width="120" prop="batchMoney" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onSubmit(scope.row.batchId)">提交</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
          <el-pagination
            background
            @size-change="batchSizeChange"
            @current-change="batchCurrentChange"
            :current-page.sync="batchForm.pageNum"
            :page-sizes="[5, 10, 20, 25, 50]"
            :page-size="batchForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { listBatch } from "@/api/business/platform";
export default {
  props: {
    batchDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      recordShow:true,
      batchListModal:this._props.batchDialog,
      total: 0,
      batchForm: {
        batchName:"",
        pageSize: 5,
        pageNum: 1,
      },
      selectBatchId: null,
      selectBatch: null,
      batchTable: [],
      batchTableLoading: false,
      statusList:['','启动审批中','启动审批不通过','进行中','进行中(结案审批中)','进行中(结案审批不通过)','已结案','进行中(关闭审批中)','进行中(关闭审批不通过)','已关闭'],
    };
  },
  watch:{
    batchDialog: {
      handler(newVal, oldVal) {
        this.batchListModal = newVal;
      },
      deep: true
    },
  },
  methods: {
    batchClose(){
      this.batchForm.batchName="";
      this.$emit('batchClose')
    },
    
    //确认
    onSubmit(){
      this.$emit('batchSave',this.selectBatchId)
    },
    //资源选择变化
    onChangeBatch(val) {
      this.selectBatch.code = val ;
    },
    //资源标签删除
    onBatchTagClose() {
      this.selectBatch = null;
      this.selectBatchId = null;
    },
    //资源选择弹窗打开
    openBatchSelectModal() {
      this.onBatchSearch();
    },
    //资源搜索
    onBatchSearch() {
      this.batchForm.pageNum = 1;
      this.getBatchList();
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    batchSizeChange(val) {
      this.batchForm.pageNum = 1;
      this.batchForm.pageSize = val;
      this.getBatchList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    batchCurrentChange(val) {
      this.batchForm.pageNum = val;
      this.getBatchList();
    },
    //获取资源列表
    getBatchList() {
      listBatch(this.batchForm).then((res) => {
        if(res.code === 1){
          this.batchTable = res.data
          this.total = res.total
        }
        console.log('========查询数========',res)
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.table-con{
    height: 270px;
    overflow: auto;
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
